import { JitsiTrack } from "lib/lib-jitsi-meet";
import { computed, IReactionDisposer, reaction } from "mobx";
import { observer } from "mobx-react";
import React from "react";
import { LocalUserState, MediaDevicesState, persistSetting, RoomState } from "../../common";

export interface IRemoteAudioTracksProps {
    roomState: RoomState;
    mediaDevicesState: MediaDevicesState;
    localUserState: LocalUserState;
}

@observer
export default class extends React.PureComponent<IRemoteAudioTracksProps> {
    @computed get audioTracks(): JitsiTrack[] {
        const audioTracks = [];
        for (const tracks of this.props.roomState.tracks.values()) {
            for (const track of tracks.filter((t) => t.getType() === "audio")) {
                audioTracks.push(track);
            }
        }
        return audioTracks;
    }
    @computed get outputDeviceId() {
        return this.props.mediaDevicesState.audioOutputDeviceId;
    }

    private audioElements: Map<JitsiTrack, HTMLAudioElement> = new Map();
    private handleRemoteAudioRef = (track: JitsiTrack) => (el: HTMLAudioElement) => {
        if (el != null) {
            this.audioElements.set(track, el);
            track.attach(el);
            (el as any).setSinkId(this.outputDeviceId);
        }
    };

    private reactions: IReactionDisposer[] = [];

    public async componentDidMount() {
        this.reactions.push(
            reaction(
                () => this.outputDeviceId,
                (id: string) => {
                    this.audioElements.forEach((el: any) => el.setSinkId(id));
                    persistSetting("audioOutputDeviceId", id);
                }
            ),
            reaction(
                () => this.props.localUserState.audioOutputLevel,
                (level) => this.audioElements.forEach((el) => (el.volume = level))
            )
        );
    }

    public async componentWillUnmount() {
        this.reactions.forEach((disposer) => disposer());
        this.audioTracks.forEach((track) => {
            track.detach(this.audioElements.get(track));
        });
    }

    public render() {
        return (
            <div>
                {this.audioTracks.map((track) => (
                    <audio
                        key={track.getId()}
                        autoPlay={true}
                        muted={true}
                        ref={this.handleRemoteAudioRef(track)}
                        data-track-id={track.getId()}
                    />
                ))}
            </div>
        );
    }
}
